export enum UserType {
  DoItYourself = 1,
  User,
  Merchandising
}

export class PermissionActivity {
  activity_type: number | null;
  visible: boolean;
  required: boolean;
  display_previous_price: boolean;
  photography_required: boolean;
  report_all_products: boolean;
  lock_gallery: boolean;
  requires_georeferencing: boolean;
  requires_selfie_upon_entry: boolean;
}

export enum RoleType {
  Web = 1,
  Mobile
}


export class User {
    id: string;
    access: string;
    refresh: string;
    expires_at: string;
    username: string;
    first_name: string;
    last_name: string;
    user_type: UserType;
    is_superuser: boolean;
    picture: string;
    user_id_number: number;
    organization: any;
    connectedToOrg: any;
    language: string;
    can_access_services?: boolean;
}
